import { useState, useEffect } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideInvestmentPlan } from './types'

export const useInvestmentPlanDetail = (businessIdeaId: string) => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [investmentPlan, setInvestmentPlan] = useState<SlideInvestmentPlan | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!businessIdeaId) return

    const investmentPlanDetail = async () => {
      setIsLoading(true)

      try {
        const response = await apiClient.business.slideInvestmentDetailList(businessIdeaId)
        setInvestmentPlan(response.data.investmentPlan)
      } catch (e) {
        console.error('収益モデルと投資計画の取得に失敗しました:', e)
        handleError(e as ApiErrorResponse, showSnackBar)
      } finally {
        setIsLoading(false)
      }
    }

    investmentPlanDetail()
  }, [businessIdeaId])

  return {
    investmentPlan,
    setInvestmentPlan,
    isInvestmentPlanLoading: isLoading,
  }
}
